/**
 * Formats a number or string as COP currency with thousands separators.
 * Example: 1500 -> "$ 1.500 COP"
 *
 * @param value The value to format
 * @returns Formatted currency string
 */
export const formatCurrency = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined) {
    return '';
  }
  const num = Number(value);
  if (isNaN(num)) {
    return '';
  }

  const formatted = new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);

  return `$ ${formatted} COP`;
};
